/* eslint-disable */
import { io, Socket } from "socket.io-client";
import { port, url } from "../../config/config";

let socket: Socket | null = null;

export const getIOInstance = (): Socket => {
	if (!socket) {
		socket = io(`${url}:${port}`, {
			path: "/socket.io", // matches your backend path for LOCAL/DEV
			transports: ["websocket"],
			autoConnect: true,
			reconnection: true,
			reconnectionAttempts: 5,
			reconnectionDelay: 1000
		});

		socket.on("connect", () => {
			console.log("[socket] connected:", socket?.id);
		});

		socket.on("disconnect", (reason) => {
			console.log("[socket] disconnected:", reason);
		});

		socket.on("connect_error", (err) => {
			console.error("[socket] connection error:", err.message);
		});
	}

	return socket;
};

// ✅ matches your backend: socket.on("joinRoom", (SSN) => socket.join(SSN))
// src/utils/socket.ts
export const joinEmployeeRoom = (SSN: string): void => {
	const s = getIOInstance();

	const doJoin = () => {
		s.emit("joinRoom", SSN);
		console.log("[socket] emitted joinRoom for SSN:", SSN);
	};

	if (s.connected) {
		doJoin();
	} else {
		s.once("connect", doJoin);
	}

	// ✅ Also re-join on reconnect (tab sleep, network blip, server restart)
	s.on("reconnect", doJoin);
};
